if (!customElements.get('soft-as-cloud-hero')) {
  class SoftAsCloudHero extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.soft-cloud-hero__images',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      if (!this.sliderWrapper) return;

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.itemsDesktop = parseFloat(this.dataset.itemsDesktop || '3');
      this.itemsTablet = parseFloat(this.dataset.itemsTablet || '2');
      this.itemsMobile = parseFloat(this.dataset.itemsMobile || '1');

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      window.addEventListener('resize', () => this.init());
    }

    init() {
      if (!this.enableSlider || !window.FoxTheme || !window.FoxTheme.Carousel) return;

      this.initSlider();
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object') return;

      const columnGap = window
        .getComputedStyle(this.sliderWrapper)
        .getPropertyValue('--f-column-gap');
      const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 16 || 32;

      const options = {
        slidesPerView: this.itemsMobile,
        spaceBetween: spaceBetween,
        pagination: {
          el: this.section.querySelector(this.selectors.pagination),
          clickable: true,
        },
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        loop: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        breakpoints: {
          768: {
            slidesPerView: this.itemsTablet,
          },
          1024: {
            slidesPerView: this.itemsDesktop,
          },
        },
      };

      this.classList.add(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.grid);
      this.sliderWrapper.classList.add(this.classes.swiperWrapper);

      this.sliderInstance = new window.FoxTheme.Carousel(this, options);
      this.sliderInstance.init();
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      if (!this.sliderWrapper) return;

      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);

      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }

  customElements.define('soft-as-cloud-hero', SoftAsCloudHero);
}

